// extracted by mini-css-extract-plugin
module.exports = {"borderBox":"borderBox___1T4rr","flexBoxCenter":"flexBoxCenter___1kReP"};